<template>
    <div>
        <div v-if="(activeCookieIntegration || !normalUser) && $store.getters.user.website_role.name != 'admin'" class="w-100 my-8 box-shadow complete-registration">
            <div class="d-flex align-start flex-column">
                <div class="d-flex flex-row justify-space-between w-100 hover" @click="showSteps = !showSteps">
                    <p class="ma-0 fs-24 fw-600">Welcome to Printdrop</p>
                    <v-img v-if="showSteps" max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/arrow_up_enabled.svg')" contain></v-img>
                    <v-img v-else max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" contain></v-img>
                </div>
                <p class="ma-0 fs-16 fw-400 hover"  @click="showSteps = !showSteps">
                    {{
                        !activeCookieIntegration && !storeWithIntegration ? 'Complete the onboarding process and start selling your product with PrintDrop.' : 'Complete onboarding process to use integration between Your Shopify  and the Printdrop application.'
                    }}

                </p>
                <div v-if="!showSteps" class="row w-100 pt-5">
                    <div class="col-md-3 d-flex flex-row" v-for="step in steps">
                        <v-img v-if="!step.value" max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/empty_circle.svg')" contain></v-img>
                        <v-img v-else max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/filled_circle.svg')" contain></v-img>
                        <p class="ma-0 fw-500 pl-2 fs-16">{{step.text}}</p>
                    </div>
                </div>
                <div v-else class="row w-100 pt-8 pb-5 h-100">
                    <div class="col-md-3 py-0 d-flex justify-space-between flex-column pr-0">
                        <div :style="{height: (100/steps.length) + '%'}" class="step_container d-flex align-center flex-row hover" @click="changeStep(index)" :class="[activeStep == index ? 'step_container-active' : 'step_container-inactive',index+1 == steps.length ? 'step_container-last' : null, index == 0 ? 'step_container-first' : null, !canGoToIndex(index) && index > 0 ? 'step-disabled' : null]" v-for="(step,index) in steps">
                            <v-img v-if="!step.value" max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/empty_circle.svg')" contain></v-img>
                            <v-img v-else max-height="24px" max-width="24px" :src="$root.getSrc('/default/drop_icons/filled_circle.svg')" contain></v-img>
                            <p class="ma-0 fw-600 pl-2 fs-18">{{step.text}}</p>
                        </div>
                    </div>
                    <div class="col-md-9 pl-0 step_info" v-if="!activeCookieIntegration && !storeWithIntegration">
                        <first-website @changeStep="activeStep++" @hideSteps="showSteps = false" v-if="activeStep == 0"></first-website>
                        <card-holder :is-shopify="false" @changeStep="activeStep++" @hideSteps="showSteps = false" v-if="activeStep == 1"></card-holder>
                        <first-product :is-shopify="false" @changeStep="activeStep++" @hideSteps="showSteps = false" v-if="activeStep == 2"></first-product>
                    </div>
                    <div class="col-md-9 pl-0 step_info" v-else>
                        <shopify-store :value="storeWithIntegration" @redirect="redirect()" @hideSteps="showSteps = false" v-if="activeStep == 0"></shopify-store>
                        <card-holder :is-shopify="true" @changeStep="activeStep++" @hideSteps="showSteps = false" v-if="activeStep == 1"></card-holder>
                        <first-product :is-shopify="true"  @changeStep="activeStep++" @hideSteps="showSteps = false" v-if="activeStep == 2"></first-product>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog :width="($vuetify.breakpoint.mdAndUp)? '25%' : '95%'" persistent :value="$product.showDialog">
            <v-card>
                <v-card-text class="pa-8">
                    <div class="d-flex align-center flex-column">
                        <div class="d-flex justify-end class w-100">
                            <v-btn
                                icon
                                dark
                                color="#575A5E"
                                @click="hideDialog"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <v-img max-height="260px" max-width="100%" :src="$root.getSrc('/default/drop_icons/finished_onboard.svg')" contain></v-img>

                        <p class="ma-0 fw-500 fs-24 black--text">Congrats!</p>
                        <p class="ma-0 pt-4 fw-400 fs-18 black--text">
                            You’ve finished onboarding process {{ !activeCookieIntegration ? 'on Printdrop' : 'from Shopify to Printdrop' }}. Now you can feel free with creating products and selling them{{!activeCookieIntegration ? '.' : ' on Shopify.'}}
                        </p>
                        <p class="ma-0 pt-4 fw-400 fs-18 black--text">
                            Start selling!
                        </p>

                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Step from './step';
import CardHolder from './card-holder'
import FirstWebsite from './first-website'
import FirstProduct from './first-product'
import ShopifyStore from './shopify-store'
import {getIntegrationsFromCookies} from "../../../utilis/integration_cookies";
import {updateShowDialog} from '@/api/user'

export default {
    components:{Step, CardHolder, FirstWebsite, FirstProduct, ShopifyStore},
    computed:{
        stepsDone(){
            return [this.$store.getters.websites && this.$store.getters.websites.length > 0, this.$store.getters.user.has_payment_method];
        },
        steps(){

            if(this.activeCookieIntegration){
                return [
                    {
                        'text': 'Connect Shopify store',
                        'value': this.storeWithIntegration,
                    },
                    {
                        'text': 'Connect payment card',
                        'value': this.$store.getters.user.has_payment_method
                    },
                    {
                        'text': 'Create your product',
                        'value': this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.amount_of_products > 0,
                        'redirect': '/products/create'
                    },
                ]
            } else {
                return [
                    {
                        'text': 'Create first website',
                        'value': this.$store.getters.activeWebsite,
                        'redirect': '/websites/create'
                    },
                    {
                        'text': 'Connect payment card',
                        'value': this.$store.getters.user.has_payment_method
                    },
                    {
                        'text': 'Create your product',
                        'value': this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.amount_of_products > 0,
                        'redirect': '/products/create'
                    },
                ]
            }


        },
        allStepsTrue(){
            let isTrue = true;
            for(let i=0 ;i<this.steps.length -1 ;i++){
                if(!this.steps[i].value) isTrue = false;
            }
            return isTrue;
        },
        activeCookieIntegration(){
            return getIntegrationsFromCookies() ? getIntegrationsFromCookies()[0] : null;
        },
        storeWithIntegration(){
            return this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.shopify_connections && this.$store.getters.activeWebsite.shopify_connections.length > 0;
        },
        normalUser(){
            let steps = this.$store.getters.websites && this.$store.getters.websites.length > 0 && this.$store.getters.user.has_payment_method && this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.amount_of_products > 0;
            if(steps && this.$store.getters.user.show_dialog) this.$product.showDialog = true;
            return steps;
        }
    },
    methods:{
        redirect(){
            window.location.href = this.$router.resolve({path: "/integration/"+this.activeCookieIntegration.type, query: this.activeCookieIntegration}).href;
        },
        changeStep(index){
            this.activeStep = index;
        },
        canGoToIndex(index){
            return true;
        },
        hideDialog(){
            this.$product.showDialog = false;
            updateShowDialog().then(res=>{
                window.location.reload();
            })
        }
    },
    data(){
        return {
            showSteps: true,
            activeStep: 0
        }
    }
}
</script>
